import React from 'react';
import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Paper } from '@mui/material';

function VersionAdoptionTable({ versionAdoption }) {
  return (
    <TableContainer component={Paper}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell style={{ fontWeight: 'bold' }}>
              App Version
            </TableCell>
            <TableCell align="right" style={{ fontWeight: 'bold' }}>
              User Count
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {versionAdoption.map((row, index) => (
            <TableRow key={index}>
              <TableCell>{row.appVersion || 'Unknown'}</TableCell>
              <TableCell align="right">{row.userCount.toLocaleString()}</TableCell>
            </TableRow>
          ))}
          {versionAdoption.length === 0 && (
            <TableRow>
              <TableCell colSpan={2} align="center" style={{ fontStyle: 'italic', color: 'gray' }}>
                No version adoption data available
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default VersionAdoptionTable;
